import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../../api/api";
import { showMessage } from "../../messages/messagesActions";
import {
  IApprovalHistory,
  IModuleActivityHistory,
} from "./approval-history.types";
import { IStoreState } from "../../store.types";

export const FETCH_APPROVAL_HISTORY_PROGRESS =
  "FETCH_APPROVAL_HISTORY_PROGRESS";
export const FETCH_APPROVAL_HISTORY_SUCCESS = "FETCH_APPROVAL_HISTORY_SUCCESS";
export const FETCH_APPROVAL_HISTORY_FAILED = "FETCH_APPROVAL_HISTORY_FAILED";
export const CLEAR_APPROVAL_HISTORY_STATE = "CLEAR_APPROVAL_HISTORY_STATE";

export const fetchApprovalHistoryProgress = () =>
  action(FETCH_APPROVAL_HISTORY_PROGRESS);

export const fetchApprovalHistorySuccess = (
  data: IApprovalHistory[],
  totalRecords: number,
  message: string,
) => action(FETCH_APPROVAL_HISTORY_SUCCESS, { data, totalRecords, message });

export const fetchApprovalHistoryFailed = (error: string) =>
  action(FETCH_APPROVAL_HISTORY_FAILED, { error });

export const clearApprovalHistoryState = () =>
  action(CLEAR_APPROVAL_HISTORY_STATE);

export const fetchApprovalHistoryAsync =
  (
    recordUuid: string,
    pageNo: number = 1,
    itemPerPage: number = 10,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchApprovalHistoryProgress());

      const url = `/approval/get-record-approval-history?record_uuid=${recordUuid}&pageNo=${pageNo}&itemPerPage=${itemPerPage}`;
      const res = await api.get(url);

      const data: IApprovalHistory[] = res.data.data || [];
      const totalRecords = res.data.totalRecords || 0;
      const message = res.data.message || "";

      dispatch(fetchApprovalHistorySuccess(data, totalRecords, message));
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch approval history";
      dispatch(fetchApprovalHistoryFailed(errorMessage));
      dispatch(
        showMessage({
          type: "error",
          message: errorMessage,
          displayAs: "snackbar",
        }),
      );
    }
  };

// #############################################################################
// Module Activity
// #############################################################################
export const FETCH_ACTIVITY_HISTORY_PROGRESS =
  "FETCH_ACTIVITY_HISTORY_PROGRESS";
export const FETCH_ACTIVITY_HISTORY_SUCCESS = "FETCH_ACTIVITY_HISTORY_SUCCESS";
export const FETCH_ACTIVITY_HISTORY_FAILED = "FETCH_ACTIVITY_HISTORY_FAILED";
export const CLEAR_ACTIVITY_HISTORY_STATE = "CLEAR_ACTIVITY_HISTORY_STATE";

export const fetchActivityHistoryProgress = () =>
  action(FETCH_ACTIVITY_HISTORY_PROGRESS);

export const fetchActivityHistorySuccess = (
  data: IModuleActivityHistory[],
  totalRecords: number,
) => action(FETCH_ACTIVITY_HISTORY_SUCCESS, { data, totalRecords });

export const fetchActivityHistoryFailed = (error: string) =>
  action(FETCH_ACTIVITY_HISTORY_FAILED, { error });

export const clearActivityHistoryState = () =>
  action(CLEAR_ACTIVITY_HISTORY_STATE);

export const fetchActivityHistoryAsync =
  (
    moduleUuid: string,
    pageNo: number = 1,
    itemPerPage: number = 10,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchActivityHistoryProgress());

      const url = `/history/get-history?module_uuid=${moduleUuid}&pageNo=${pageNo}&itemPerPage=${itemPerPage}`;
      const res = await api.get(url);

      const data: IModuleActivityHistory[] = res.data.data || [];
      const totalRecords = res.data.totalRecords || 0;

      dispatch(fetchActivityHistorySuccess(data, totalRecords));
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch activity history";
      dispatch(fetchActivityHistoryFailed(errorMessage));
      dispatch(
        showMessage({
          type: "error",
          message: errorMessage,
          displayAs: "snackbar",
        }),
      );
    }
  };
